import { SVG, SVGProps } from './svg'

export function IconCaretRight(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M10.5 17.8a.7.7 0 0 1-1 0l-.3-.3A.7.7 0 0 1 9 17V7c0-.2 0-.4.2-.5l.3-.3a.7.7 0 0 1 1 0l5.3 5.3a.7.7 0 0 1 0 1l-5.3 5.3Z" />
    </SVG>
  )
}
